




















































































































































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  TreatmentMonitoringApi,
  UnitModel,
  VariableDataModel,
  WriteVariable,
} from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { msToVariableTime } from ".";

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class Param extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: () => {} }) unit: UnitModel;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  variables: any[] = [];
  variablesOriginal: any[] = [];

  get show() {
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.parameters"),
        value: "variable.variableName",
        cellClass: [this.$screen.isMobile() ? '' : 'tw-whitespace-no-wrap'],
      },
      {
        text: this.$t("text.value"),
        value: "value",
        width: this.$screen.isMobile() ? 'auto' : 200,
        cellClass: [this.$screen.isMobile() ? '' : 'tw-whitespace-no-wrap', "tw-p-0"],
      },
    ] as DataTableHeader[];
  }

  get BOOL_VALUES() {
    return [
      { text: "ON", value: 1 },
      { text: "OFF", value: 0 },
    ];
  }

  onShow() {
    this.getStatusParams();
  }

  async getStatusParams() {
    this.$util.showLoading();
    try {
      const { id: unitId } = this.$route.params;
      const rs =
        await new TreatmentMonitoringApi().getVariableDatasByUnitIdTabName({
          unitId,
          tabName: "PARAMETERS",
        });
      this.variables = rs.data.data.map((val) => {
        if (val.variable.type === "TIME" && val.value != null) {
          const value = msToVariableTime(val.value / 1000);
          return { ...val, value };
        }
        return val;
      });
      this.variablesOriginal = JSON.parse(JSON.stringify(this.variables));
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  findDiffParam() {
    const paramsDiff = [];
    const variableDataIds = this.variables.map((variable) => variable.id);
    for (let variableDataId of variableDataIds) {
      const variableOriginal = this.variablesOriginal.find(variable => variable.id === variableDataId);
      const variableUpdated = this.variables.find(variable => variable.id === variableDataId);
      if (Number.parseFloat("" + variableOriginal.value) !== Number.parseFloat("" + variableUpdated.value)) {
        paramsDiff.push(variableDataId);
      }
    }
    return paramsDiff;
  }

  async doSave() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }

    this.$util.showLoading();
    const updatedParams = this.findDiffParam();
    try {
      const writeVariables: any[] = this.variables.filter((variable) => updatedParams.includes(variable.id)).map((val) => {
        if (val.variable.type === "TIME") {
          const valArr = ("" + val.value).match(/(\d{2})(\d{2})(\d{2})(\d{2})/);
          if (valArr && valArr.length >= 5) {
            const day = Number.parseInt(valArr[1]);
            const hour = Number.parseInt(valArr[2]);
            const minute = Number.parseInt(valArr[3]);
            const second = Number.parseInt(valArr[4]);
            return {
              variableId: val.variable.id,
              value:
                (day * 24 * 3600 + hour * 3600 + minute * 60 + second) * 1000,
            };
          }
          return {
            variableId: val.variable.id,
            value: 0,
          };
        }
        return {
          variableId: val.variable.id,
          value: Number.parseFloat("" + val.value),
        };
      });
      if (writeVariables.length > 0) {
        await new TreatmentMonitoringApi().submitVariableData({
          postSubmitVariableDataRequest: {
            // variableDatas: this.variables,
            locationId: this.unit.location.id,
            writeData: writeVariables,
          },
        });
      }
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
